"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
require("./Search.css");
var Icon_1 = require("../../icon/Icon");
var Button_1 = require("../../button/Button");
var react_1 = require("react");
var Dropdown_1 = require("../../dropdown/Dropdown");
var keyboard_1 = require("../../../utils/dom/keyboard");
var SearchComp = function (props) {
    var htmlProps = (function (_a) {
        var value = _a.value, disabled = _a.disabled, onReturn = _a.onReturn, onChange = _a.onChange, onInputClick = _a.onInputClick, onSubmit = _a.onSubmit, rest = __rest(_a, ["value", "disabled", "onReturn", "onChange", "onInputClick", "onSubmit"]);
        return rest;
    })(props);
    var dropdownProps = Dropdown_1.useDropdownContext();
    //--- states ---//
    var searchInput = react_1.useRef(null);
    var _a = __read(react_1.useState(''), 2), searchValue = _a[0], setSearchValue = _a[1];
    //--- effects ---//
    react_1.useEffect(function () {
        dropdownProps.setDropdownClassName('Dropdown-search');
        dropdownProps.setAriaLabel('Search dropdown');
    }, []);
    react_1.useEffect(function () {
        if (dropdownProps.expanded && searchInput.current) {
            setTimeout(function () { var _a; return (_a = searchInput.current) === null || _a === void 0 ? void 0 : _a.focus(); });
        }
    }, [dropdownProps.expanded]);
    react_1.useEffect(function () {
        if (props.value)
            setSearchValue(props.value);
    }, [props.value]);
    //--- Callback methods ---//
    var onSubmitClick = function (e) {
        if (searchInput.current) {
            var value = searchInput.current.value.trim();
            dropdownProps.closeDropdown();
            if (props.onSubmit)
                props.onSubmit(value, e);
        }
    };
    return (React.createElement("div", __assign({}, htmlProps, { className: classnames_1.default('Search', props.className, {
            'Search-disabled': props.disabled,
        }) }),
        React.createElement("div", { className: 'd-flex align-items-center w-100' },
            React.createElement(Icon_1.Icon, { type: Icon_1.IconType.search, className: 'Search_inputIcon' }),
            React.createElement("input", { ref: searchInput, type: "search", className: 'Search_input', value: searchValue, tabIndex: dropdownProps.isHidden ? -1 : undefined, disabled: props.disabled, onClick: function (e) {
                    if (props.onInputClick)
                        props.onInputClick(e);
                }, onKeyUp: function (e) {
                    if (e.keyCode === 13) {
                        //return key
                        var value = e.target.value.trim();
                        if (value && value.length > 0) {
                            dropdownProps.closeDropdown();
                            if (props.onReturn)
                                props.onReturn(value, e);
                            if (props.onSubmit)
                                props.onSubmit(value, e);
                        }
                    }
                }, onChange: function (e) {
                    var value = e.target.value;
                    setSearchValue(value);
                    if (props.onChange)
                        props.onChange(value, e);
                } })),
        React.createElement(Button_1.Button, { className: 'Search_submit', "aria-label": 'Search submit', tabIndex: dropdownProps.isHidden ? -1 : undefined, disabled: props.disabled, onKeyDown: function (e) {
                //prevent click from firing multiple times in firefox
                if (keyboard_1.isKeyReturn(e) || keyboard_1.isKeySpacebar(e))
                    e.preventDefault();
            }, onKeyUp: function (e) {
                //fire click only on keyUp
                if (keyboard_1.isKeyReturn(e) || keyboard_1.isKeySpacebar(e))
                    onSubmitClick(e);
            }, onClick: onSubmitClick },
            React.createElement(Icon_1.Icon, { type: Icon_1.IconType.longArrowRight, "aria-hidden": true }))));
};
exports.Search = React.memo(SearchComp);
